import { IntersectionType, PartialType, PickType } from '@nestjs/swagger';
import { SpModelNameCreatableInterface } from '../interfaces/sp-model-name-creatable.interface';
import { SpModelNameDto } from './sp-model-name.dto';

export class SpModelNameCreateDto
  extends IntersectionType(
    PickType(SpModelNameDto, ['spName', 'modelId', 'subdivisionId']),
    PartialType(PickType(SpModelNameDto, ['active'])),
  )
  implements SpModelNameCreatableInterface {}
